




































































import { Component, Vue } from "vue-property-decorator";
import http from "@/axios/http-common";
import TabBerkasRm from "@/components/pemeriksaan/berkasRm/TabBerkasRm.vue";

@Component({ components: { TabBerkasRm } })
export default class BerkasRmPage extends Vue {
  pasienItems: any[] = [];
  pasienLoading = false;
  pasienSearch: string | null = null;
  selectedPasien: any = null;

  get selectedRm(): string {
    return this.selectedPasien && typeof this.selectedPasien === "object"
      ? this.selectedPasien.rm
      : "";
  }

  get pasienNama(): string {
    return this.selectedPasien?.nama || "";
  }

  get pasienSex(): string {
    return this.selectedPasien?.sex || "";
  }

  get pasienUsia(): string {
    return this.selectedPasien?.usia || "";
  }

  pasienItemText(item: any): string {
    return item && typeof item === "object"
      ? `${item.rm} — ${item.nama}`
      : "";
  }

  pasienFilter(item: any, queryText: string): boolean {
    const q = (queryText || "").toLowerCase();
    return (
      String(item.rm || "").toLowerCase().indexOf(q) > -1 ||
      String(item.nama || "").toLowerCase().indexOf(q) > -1
    );
  }

  async doPasienSearch() {
    if (!this.pasienSearch) {
      this.pasienItems = [];
      return;
    }
    this.pasienLoading = true;
    try {
      const res = await http.getDataParam("/pasien", {
        params: { term: this.pasienSearch }
      });
      this.pasienItems = res.data || [];
    } catch (e) {
      this.pasienItems = [];
    } finally {
      this.pasienLoading = false;
    }
  }

  onPasienSelect(v: any) {
    if (!v || typeof v !== "object") {
      this.selectedPasien = null;
    }
  }
}
